import { __assign, __extends } from "tslib";
import React from 'react';
import { currencyFormatter } from '../utils.js';
import moments from 'moment';
import { View, Text } from 'react-native';
import { PnmacHtmlToNative, PnmacInputRowMobile } from 'pnmac-universal-components';
import styles from '../styles/styles.js';
import { textStyle } from '../v2/theme/textStyle.js';
var YearEndTax = /** @class */function (_super) {
  __extends(YearEndTax, _super);
  function YearEndTax() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  YearEndTax.prototype.render = function () {
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations,
      is1098Mailed = _a.is1098Mailed,
      correctionFlag1098 = _a.correctionFlag1098,
      mortgageInterestAmount = _a.mortgageInterestAmount,
      unpaidPrincipalBalanceAmount = _a.unpaidPrincipalBalanceAmount,
      mortgageOriginationDate = _a.mortgageOriginationDate,
      overpaidInterestRefundAmount = _a.overpaidInterestRefundAmount,
      mortgageInsurancePremiumAmount = _a.mortgageInsurancePremiumAmount,
      principalResidencePurchasePaidPointsAmount = _a.principalResidencePurchasePaidPointsAmount,
      otherInformation = _a.otherInformation,
      mortgageAcquisitionDate = _a.mortgageAcquisitionDate,
      is1099IntMailed = _a.is1099IntMailed,
      is1099I30 = _a.is1099I30,
      correctionFlag1099INT = _a.correctionFlag1099INT,
      interestIncomeAmount = _a.interestIncomeAmount,
      federalIncomeTaxWithheldAmount = _a.federalIncomeTaxWithheldAmount,
      is1098I30 = _a.is1098I30;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        backgroundColor: "#FFF"
      }
    }, is1098Mailed || is1098I30 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Heading"]),
      value: ""
    }), correctionFlag1098 ? /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations.TaxCorrected),
      value: "True"
    }) : null) : null, /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Box1"]),
      value: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, currencyFormatter('en-US', 'currency', 'USD', mortgageInterestAmount))
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Box2"]),
      value: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, currencyFormatter('en-US', 'currency', 'USD', unpaidPrincipalBalanceAmount))
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Box3"]),
      value: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, moments(mortgageOriginationDate).format("MM/DD/YYYY"))
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Box4"]),
      value: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, currencyFormatter('en-US', 'currency', 'USD', overpaidInterestRefundAmount))
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Box5"]),
      value: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, currencyFormatter('en-US', 'currency', 'USD', mortgageInsurancePremiumAmount))
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Box6"]),
      value: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, currencyFormatter('en-US', 'currency', 'USD', principalResidencePurchasePaidPointsAmount))
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Box10"]),
      value: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, currencyFormatter('en-US', 'currency', 'USD', otherInformation))
    }), mortgageAcquisitionDate ? /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, translations["1098Box11"]),
      value: /*#__PURE__*/React.createElement(Text, {
        style: textStyle.formBody
      }, moments(mortgageAcquisitionDate).format("MM/DD/YYYY"))
    }) : null, is1099IntMailed || is1099I30 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: {
          fontWeight: "bold"
        }
      }, translations["1099INTHeading"]),
      value: ""
    }), correctionFlag1099INT ? /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: {
          fontWeight: "bold"
        }
      }, translations["TaxCorrected"]),
      value: "True"
    }) : null, /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: {
          fontWeight: "bold"
        }
      }, translations["1099Box1"]),
      value: currencyFormatter('en-US', 'currency', 'USD', interestIncomeAmount)
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: /*#__PURE__*/React.createElement(Text, {
        style: {
          fontWeight: "bold"
        }
      }, translations["1099Box4"]),
      value: currencyFormatter('en-US', 'currency', 'USD', federalIncomeTaxWithheldAmount)
    })) : null, is1098I30 || is1098I30 || is1099IntMailed || is1098Mailed ? /*#__PURE__*/React.createElement(View, {
      style: layout.mobile ? __assign(__assign({}, styles.shadowStyles), {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        backgroundColor: "white",
        padding: 20
      }) : {
        padding: 20
      }
    }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, this.props, {
      value: translations.TaxYearEndNote1
    }))) : null);
  };
  return YearEndTax;
}(React.Component);
export default YearEndTax;